/* Http Client */
import request from '@/utils/http/request'


export const STATUS = {
    1: "啟用",
    0: "停用",
}
//List
export async function fetchAll({ name, phone, pageSize, pageNumber }) {
    return await request.get('/blacklist', {
        params: {
            name, phone, pageSize, pageNumber
        }

    });
}

//運動類型添加
export async function store({ phone, day }) {
    return await request.post('/blacklist', {
        phone, day
    });
}

//運動類型刪除
export async function destroy(id) {
    return await request.delete(`/blacklist/${id}`);
}


